import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'br'];

export const sanitizeHtml = html => DOMPurify.sanitize(html, { ALLOWED_TAGS });
